import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import bgImg from '../assets/images/bg-guide01.png';
import adTitleImg from '../assets/images/ad-title.png';
import adDescImg from '../assets/images/ad-desc.png';
import adPopupImg from '../assets/images/ad-popup.png';
import btnRegister from '../assets/images/05tale-confirm-btn.png';
import banpageImg from '../assets/images/banpage.png';
import banpageBtnImg from '../assets/images/banpage-btn.png';
import banpopupImg from '../assets/images/banpopup.png';
import SentMessages from '../components/SentMessages';

const FadeInBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 100vw;
  height: 100dvh;
  min-height: 100dvh;
  background: url(${bgImg}) center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.5s ease;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: ${({ visible }) => 1 - visible};
    transition: opacity 0.9s ease;
    z-index: -1;
  }
`;

const Title = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 35vw;
  max-width: 90vw;
  margin-top: 5dvh;
  margin-bottom: 4dvh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.9s ease;
`;

const Desc = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 85vw;
  max-width: 600px;
  margin-top: 4dvh;
  margin-bottom: 5dvh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.9s ease;
`;

const PopupImage = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 80vw;
  max-width: 400px;
  height: auto;
  position: absolute;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.9s ease;
`;

const RegisterButton = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 90vw;
  max-width: 90vw;
  position: absolute;
  left: 50%;
  bottom: 5vh;
  transform: translateX(-50%);
  cursor: pointer;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.9s ease;
`;

// 접속만료 페이지 스타일
const ValidationOverlay = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: ${({ $visible }) => $visible ? 1 : 0};
  visibility: ${({ $visible }) => $visible ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

const BanPageImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const BanPageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const BanPageButton = styled.button`
  position: absolute;
  top: calc(10% + 95dvw);
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
  z-index: 10000;
  
  &:hover {
    transform: translateX(-50%) scale(1.05);
  }
  
  &:active {
    transform: translateX(-50%) scale(0.95);
  }
`;

const BanPageButtonImage = styled.img`
  width: 100%;
  height: auto;
`;

const BanPopupImage = styled.img`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  z-index: 10002;
  pointer-events: none;
`;

const AdPage: React.FC = () => {
  const [bgVisible, setBgVisible] = useState(0);
  const [titleVisible, setTitleVisible] = useState(0);
  const [descVisible, setDescVisible] = useState(0);
  const [popupVisible, setPopupVisible] = useState(0);
  const [registerVisible, setRegisterVisible] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [showValidationOverlay, setShowValidationOverlay] = useState(false);
  const [showSentMessages, setShowSentMessages] = useState(false);

  useEffect(() => {
    // AdPage 접속 시 periodicPopupCount 초기화
    localStorage.setItem('periodicPopupCount', '0');
    
    const bgTimer = setTimeout(() => setBgVisible(1), 100);
    // 타이틀 이미지는 즉시 표시
    setTitleVisible(1);
    const descTimer = setTimeout(() => setDescVisible(1), 700);
    // ad-desc.png가 뜬 직후 팝업 표시 (800ms 후)
    const popupTimer = setTimeout(() => setPopupVisible(1), 800);
    // 확인 버튼 표시 (1500ms 후)
    const registerTimer = setTimeout(() => setRegisterVisible(1), 1500);
    return () => {
      clearTimeout(bgTimer);
      clearTimeout(descTimer);
      clearTimeout(popupTimer);
      clearTimeout(registerTimer);
    };
  }, []);

  const handleRegisterClick = () => {
    // 새 창에서 밀리의 서재 링크 열기
    window.open('https://www.millie.co.kr/v4/book/ef05bb24daac40e0', '_blank');
    
    // 2초 후 접속만료 페이지 표시
    setTimeout(() => {
      setShowValidationOverlay(true);
    }, 2000);
  };

  return (
    <>
      <FadeInBackground visible={bgVisible} isFadingOut={isFadingOut}>
        <Title src={adTitleImg} alt="광고 타이틀" visible={titleVisible} isFadingOut={isFadingOut} />
        <Desc src={adDescImg} alt="광고 설명" visible={descVisible} isFadingOut={isFadingOut} />
        <PopupImage 
          src={adPopupImg} 
          alt="광고 팝업" 
          visible={popupVisible} 
          isFadingOut={isFadingOut}
        />
        <RegisterButton 
          src={btnRegister} 
          alt="확인" 
          visible={registerVisible} 
          isFadingOut={isFadingOut}
          onClick={handleRegisterClick}
        />
      </FadeInBackground>
      
      {/* 접속만료 페이지 */}
      <ValidationOverlay $visible={showValidationOverlay}>
        <BanPageContainer>
          <BanPageImage src={banpageImg} alt="접근 제한" />
          <BanPopupImage src={banpopupImg} alt="벤 팝업" />
          <BanPageButton onClick={() => {
            setShowSentMessages(true);
          }}>
            <BanPageButtonImage src={banpageBtnImg} alt="보낸 메시지 보기" />
          </BanPageButton>
        </BanPageContainer>
      </ValidationOverlay>
      
      {/* SentMessages 컴포넌트 */}
      {showSentMessages && (
        <SentMessages onClose={() => {
          setShowSentMessages(false);
        }} />
      )}
    </>
  );
};

export default AdPage;
